import { render, staticRenderFns } from "./Navegacao.vue?vue&type=template&id=438b439a&scoped=true&lang=pug&"
import script from "./Navegacao.vue?vue&type=script&lang=js&"
export * from "./Navegacao.vue?vue&type=script&lang=js&"
import style0 from "./Navegacao.styl?vue&type=style&index=0&id=438b439a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438b439a",
  null
  
)

export default component.exports